const getLocationType = (location?: string): string => {
  /* Parses the type of location from the location search parameter
   * and returns the correct event type.
   *
   * Zip code searches return 'zip-code'
   * City searches return 'city'
   * Other searches return 'address'
   */
  const zipRegex = /\d{5}/;
  if (!location) {
    return 'city';
  }

  if (/\d/.test(location.replace(zipRegex, '')) === true) {
    return 'address';
  }

  if (zipRegex.test(location) === true) {
    return 'zip-code';
  }

  return 'city';
};

export default getLocationType;
